import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCookieBite } from '@fortawesome/free-solid-svg-icons';

const COOKIE_KEY = 'quero_cookie_consent';

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const saved = localStorage.getItem(COOKIE_KEY);
        if (!saved) {
            // Small delay so it doesn't flash immediately on load
            const t = setTimeout(() => setVisible(true), 800);
            return () => clearTimeout(t);
        }
    }, []);

    const accept = () => {
        localStorage.setItem(COOKIE_KEY, 'accepted');
        setVisible(false);
    };

    const decline = () => {
        localStorage.setItem(COOKIE_KEY, 'declined');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            style={{
                position: 'fixed',
                bottom: '1.5rem',
                left: '50%',
                transform: 'translateX(-50%)',
                width: 'calc(100% - 3rem)',
                maxWidth: '720px',
                zIndex: 9999,
                animation: 'slideUpFade 0.4s ease',
            }}
        >
            <div
                className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3 px-4 py-3 rounded-4 shadow-lg"
                style={{
                    background: 'rgba(15, 23, 42, 0.96)',
                    backdropFilter: 'blur(14px)',
                    border: '1px solid rgba(255,255,255,0.08)',
                    color: '#fff',
                }}
            >
                {/* Text */}
                <div className="d-flex align-items-start gap-3 flex-1">
                    <FontAwesomeIcon icon={faCookieBite} style={{ color: '#fff', fontSize: '2rem', flexShrink: 0, marginTop: '2px' }} />
                    <div>
                        <p className="mb-0 fw-semibold" style={{ fontSize: '0.88rem' }}>
                            Ta strona używa plików cookie
                        </p>
                        <p className="mb-0 text-white opacity-60" style={{ fontSize: '0.78rem', marginTop: '2px' }}>
                            Używamy ich do analizy ruchu i poprawy działania serwisu. Twój wybór zostanie zapamiętany.
                        </p>
                    </div>
                </div>

                {/* Buttons */}
                <div className="d-flex align-items-center gap-2 flex-shrink-0">
                    <button
                        onClick={decline}
                        className="btn btn-sm rounded-pill px-4 fw-semibold"
                        style={{
                            background: 'rgba(255,255,255,0.08)',
                            color: '#fff',
                            border: '1px solid rgba(255,255,255,0.15)',
                            fontSize: '0.8rem',
                        }}
                    >
                        Odrzuć
                    </button>
                    <button
                        onClick={accept}
                        className="btn btn-primary btn-sm rounded-pill px-4 fw-bold"
                        style={{ fontSize: '0.8rem' }}
                    >
                        Akceptuję
                    </button>
                </div>
            </div>

            <style>{`
                @keyframes slideUpFade {
                    from { opacity: 0; transform: translateX(-50%) translateY(20px); }
                    to   { opacity: 1; transform: translateX(-50%) translateY(0); }
                }
            `}</style>
        </div>
    );
}
